import React, { useState } from "react";
import { ActionBar, ActionBarProps } from "../../../pages/components/action-bar/action-bar";
import { Message, MessageSections } from "../../../pages/components/message/message";
import {
    messagesManagementActions,
    WarehouseManagementActions,
    WarehouseManagementWarehouseWorkersActions
} from "../../actions/actions-by-state";
import { ManagementPageType } from "../management-data-container";
import { ActionDialog } from "../../actions/dialogs/action-dialog";
import { WarehouseManagementActionTypes } from "../../actions/action-types.enum";
import { useParams } from "react-router-dom";

export const ManagementActionBar = ({ actionbarMessageKey, type, withBackButton, onActionDialogClosed, overallItems }: ManagementActionBarProps) => {
    const { warehouseId } = useParams()

    function getActions(): any[] | undefined {
        switch (type) {
            case ManagementPageType.WAREHOUSES:
                return WarehouseManagementActions;
            case ManagementPageType.WAREHOUSE_WORKERS:
                return warehouseId ? WarehouseManagementWarehouseWorkersActions : undefined;
            case ManagementPageType.MESSAGES:
                return messagesManagementActions;
        }
        return undefined;
    }

    const [actions] = useState(getActions());
    const [activeAction, setActiveAction] = useState<WarehouseManagementActionTypes>();

    function onActionClick(actionId: string) {
        setActiveAction(actionId as WarehouseManagementActionTypes);
    }

    function handleActionPopupClose() {
        setActiveAction(undefined);

        onActionDialogClosed && onActionDialogClosed();
    }

    if (actionbarMessageKey) {
        return (
            <>
                <ActionBar headerText={<Message messageKey={actionbarMessageKey} sectionId={MessageSections.MAIN} />}
                    actions={actions}
                    actionFunction={onActionClick}
                    withBackButton={withBackButton}
                    overallItems={overallItems}
                />
                <ActionDialog open={!!activeAction}
                    closePopup={() => handleActionPopupClose()}
                    action={activeAction}
                    messageSection={MessageSections.MAIN} />
            </>
        )
    } else {
        return <></>
    }
}

interface ManagementActionBarProps extends ActionBarProps {
    type: ManagementPageType,
    actionbarMessageKey?: string,
    onActionDialogClosed?: () => void,
    overallItems?: number,
}
